import { env } from '@/config/env';

/** Tâm thời tiết mặc định (nội thành Hà Nội) — khác tâm bản đồ toàn cảnh Việt Nam. */
export const HANOI_WEATHER_REFERENCE: { lat: number; lng: number } = {
  lat: 21.0285,
  lng: 105.8542,
};

/**
 * Operational weather reference point: priorities
 * `VITE_WEATHER_DEFAULT_LAT` / `VITE_WEATHER_DEFAULT_LON`, otherwise {@link HANOI_WEATHER_REFERENCE}.
 * At runtime, ưu tiên geolocation / cache trình duyệt (see `useWeatherOperationalMapSync`).
 */
export function getOperationalWeatherCoordinates(): { lat: number; lng: number } {
  if (env.WEATHER_DEFAULT_LAT != null && env.WEATHER_DEFAULT_LON != null) {
    return { lat: env.WEATHER_DEFAULT_LAT, lng: env.WEATHER_DEFAULT_LON };
  }
  return { lat: HANOI_WEATHER_REFERENCE.lat, lng: HANOI_WEATHER_REFERENCE.lng };
}

/**
 * Nhãn địa điểm do vận hành cấu hình (`VITE_WEATHER_LOCATION_DISPLAY_NAME`).
 * Dùng để minh bạch trên UI khi chưa có geocode / chọn địa danh động.
 *
 * Mở rộng sau (tách khỏi điểm cố định): geocode địa chỉ người dùng hoặc bind tọa độ theo vùng/trạm
 * chọn trên bản đồ — cần luồng xác nhận riêng để không lẫn điểm vận hành.
 */
export function getOperationalWeatherLocationLabel(): string | null {
  return env.WEATHER_LOCATION_DISPLAY_NAME;
}
